<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      石芽岭站<br>
站点介绍<br>
石芽岭站位于盛宝路和科技园路与布澜路交叉口处,沿盛宝路和科技园路东西布置。车站东北侧为布吉交警中队，西北侧为瑞穗精密厂，东南侧为庄氏大厦，西南侧为宇宏健康花城小区。西接布吉站，东接六约北站。 车站以“科技长廊”为主题，把原本的地铁空间赋予生态的语言，摒弃传统的空间单一，打造多维度的空间体验感，还原城市人的科技绿廊梦。以科技树技的设计元素为空间设计灵感，结合模拟天光以及建筑的一体化设计，使整个空间如室外般的通造、明亮。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:42	23:40	14号线	4分30秒	6分15秒<br>
沙田	06:14	23:44	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:40	23:40	14号线	5分25秒	6分15秒<br>
沙田	06:14	23:44	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:40	00:40	14号线	5分钟	6分15秒<br>
沙田	06:14	00:44	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
科技园路南侧<br><br>
A2出入口:<br>
布澜路西侧（南）、宇宏健康花城<br><br>
B出入口:<br>
布澜路东侧（南）、南湾学校<br><br>
H出入口:<br>
盛宝路北侧<br><br>
J出入口:<br>
布澜路东侧（北）、深圳市公安局交通警察支队龙岗大队布吉中队<br><br>
K出入口:<br>
布澜路西侧（北）<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 来座山站<br>
B741、M203、M224、M403、M585、高峰专线73路、M150<br><br>
A2出入口:<br>
公交站名： 布吉交警中队站<br>
322、977、M192、M273、M300、M589、M324、M329、M363、M402、M491、M508、M547、M565、M585<br><br>
J出入口:<br>
公交站名： 布吉交警中队站<br>
322、977、M589、M192、M585、M273、M300、M324、M329、M311、M363、M491、M508、M547、M150、M224<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>